import { createControlState } from '../controls/controller';
import { worldToLayout } from '../core/coords';
import type { ControlState, ControlEnv, Pose, SettledMode } from '../controls/types';
import type { Vec2 } from '../geo/types';

/** Where and how the visitor starts: at the painter's view, on the Dam, or at a pose asked for. */
export function createInitialControlState(
  options: { view: { kind: string; pose?: Pose }; mode: SettledMode },
  spawn: Vec2,
  painterPose: Pose,
  env: ControlEnv
): ControlState {
  if (options.view.kind === 'pose' && options.view.pose) {
    const { pose } = options.view;
    // A boat lies on the water nearest the asked pose, its bow the way the pose looks.
    const afloat =
      options.mode === 'boat'
        ? createControlState(worldToLayout(pose.position), 'boat', env, pose.yaw)
        : null;
    if (afloat?.mode === 'boat') {
      return { ...afloat, pose: { ...afloat.pose, pitch: pose.pitch } };
    }
    const state = createControlState(spawn, options.mode === 'boat' ? 'walk' : options.mode, env);
    return { ...state, pose };
  }
  if (options.view.kind === 'spawn') {
    return createControlState(spawn, options.mode, env);
  }
  const state = createControlState(spawn, 'fly', env);
  return { ...state, pose: painterPose, atPainterView: true };
}
